export const LOAD_PRODUCT_GROUPS = 'LOAD_PRODUCT_GROUPS';
export const ADD_NEW_PRODUCT_GROUPS = 'ADD_NEW_PRODUCT_GROUPS';
export const UPDATE_TRANSLATE_PRODUCT_GROUPS = 'UPDATE_TRANSLATE_PRODUCT_GROUPS';
export const GO_TO_STEP_OF_PRODUCT_GROUPS_FORM = 'GO_TO_STEP_OF_PRODUCT_GROUPS_FORM';
export const EDIT_PRODUCT_GROUPS = 'EDIT_PRODUCT_GROUPS';
export const LOAD_EDITABLE_PRODUCT_GROUPS = 'LOAD_EDITABLE_PRODUCT_GROUPS';
export const LOAD_EDITTABLE_PACKAGES_FROM_PRODUCT_GROUPS = 'LOAD_EDITTABLE_PACKAGES_FROM_PRODUCT_GROUPS';
export const LOAD_DISPLAY_USERS_FOR_ATTACHED_PACKAGES = 'LOAD_DISPLAY_USERS_FOR_ATTACHED_PACKAGES';
export const SET_EMPTY_EDITABLE_PRODUCT_GROUPS = 'SET_EMPTY_EDITABLE_PRODUCT_GROUPS';
export const SET_PRODUCT_GROUPS_PAGINATION = 'SET_PRODUCT_GROUPS_PAGINATION';
export const SET_PRODUCT_GROUPS_FILTER = 'SET_PRODUCT_GROUPS_FILTER';
export const SET_PRODUCT_GROUPS_SORT = 'SET_PRODUCT_GROUPS_SORT';
export const RESET_PRODUCTS_GROUPS_FILTERS = 'RESET_PRODUCTS_GROUPS_FILTERS';
export const TOGGLE_PRODUCT_GROUPS_STATUS = 'TOGGLE_PRODUCT_GROUPS_STATUS';
export const BULK_CHECKED_GROUPS_STATUS = 'BULK_CHECKED_GROUPS_STATUS';
export const SET_CHECKED_GROUPS_STATUS = 'SET_CHECKED_GROUPS_STATUS';
export const LOAD_SELL_PRICE = 'LOAD_SELL_PRICE';
export const SET_RESELLER_FOR_SELL_PRICE = 'SET_RESELLER_FOR_SELL_PRICE';
export const LOAD_PRODUCT_GROUP_FOR_SELL_PRICE = 'LOAD_PRODUCT_GROUP_FOR_SELL_PRICE';
export const UPDATE_SELL_PRICE = 'UPDATE_SELL_PRICE';
export const SET_EMPTY_PRODUCT_GROUP_FROM_SELL_PRICE = 'SET_EMPTY_PRODUCT_GROUP_FROM_SELL_PRICE';
export const SET_CHECKED_SELL_PRICE = 'SET_CHECKED_SELL_PRICE';
export const TOGGLE_COST_STATUS_BY_SELL_PRICE = 'TOGGLE_COST_STATUS_BY_SELL_PRICE';
export const SET_SELL_PRICE_PAGINATION = 'SET_SELL_PRICE_PAGINATION';
export const SET_SELL_PRICE_SORT = 'SET_SELL_PRICE_SORT';
export const SET_SELL_PRICE_FILTERS = 'SET_SELL_PRICE_FILTERS';
export const RESET_SELL_PRICE_FILTERS = 'RESET_SELL_PRICE_FILTERS';
export const UPDATE_PACKAGES_TO_LIST_PRODUCT_GROUPS = 'UPDATE_PACKAGES_TO_LIST_PRODUCT_GROUPS';
export const ADD_BULK_PACKAGES_FOR_PRODUCT_GROUPS = 'ADD_BULK_PACKAGES_FOR_PRODUCT_GROUPS';
export const DELETE_BULK_PACKAGES_FOR_PRODUCT_GROUPS = 'DELETE_BULK_PACKAGES_FOR_PRODUCT_GROUPS';
export const RESET_PACKAGE_FROM_PRODUCT_GROUPS = 'RESET_PACKAGE_FROM_PRODUCT_GROUPS';
export const RESET_CHOSEN_PACKAGES_PAGINATION_FROM_PRODUCT_GROUP = 'RESET_CHOSEN_PACKAGES_PAGINATION_FROM_PRODUCT_GROUP';
export const LOAD_PACKAGES_FOR_PRODUCT_GROUPS = 'LOAD_PACKAGES_FOR_PRODUCT_GROUPS';
export const LOAD_USERS_FOR_PACKAGE = 'LOAD_USERS_FOR_PACKAGE';
export const SET_PACKAGES_FILTERS_FOR_PRODUCT_GROUP = 'SET_PACKAGES_FILTERS_FOR_PRODUCT_GROUP';
export const SET_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP = 'SET_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP';
export const SET_PACKAGES_SORT_FOR_PRODUCT_GROUP = 'SET_PACKAGES_SORT_FOR_PRODUCT_GROUP';
export const RESET_PACKAGES_FILTERS_FOR_PRODUCT_GROUP = 'RESET_PACKAGES_FILTERS_FOR_PRODUCT_GROUP';
export const RESET_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP = 'RESET_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP';
export const SET_CHOSEN_PACKAGES_FILTERS_FOR_PRODUCT_GROUP = 'SET_CHOSEN_PACKAGES_FILTERS_FOR_PRODUCT_GROUP';
export const SET_CHOSEN_PACKAGES_SORT_FOR_PRODUCT_GROUP = 'SET_CHOSEN_PACKAGES_SORT_FOR_PRODUCT_GROUP';
export const RESET_CHOSEN_PACKAGES_FILTERS_FOR_PRODUCT_GROUP = 'RESET_CHOSEN_PACKAGES_FILTERS_FOR_PRODUCT_GROUP';
export const SET_CHOSEN_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP = 'SET_CHOSEN_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP';
export const SET_CHECKED_PACKAGES_FOR_PRODUCT_GROUPS = 'SET_CHECKED_PACKAGES_FOR_PRODUCT_GROUPS';
